<div class="input-group">
  <input type="number" class="form-control" appIntegerValueAccessor />
  <span class="input-group-btn">
    <button class="btn btn-success" type="button" (click)="apply()">Set <i class="glyphicon glyphicon-tasks"></i></button>
  </span>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/treatment-count-input/treatment-count-input.component.html